<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ 'contacts.title' | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <section class="creation-form">
      <button *ngIf="!isCreationMode && isDispatcher" (click)="onEdit()" [matTooltip]="'contacts.list.add' | translate"
        mat-mini-fab class="action-button" color="primary">
        <mat-icon aria-label="Add">person_add</mat-icon>
      </button>
      <app-contact-edit *ngIf="isCreationMode && !editedId" (editFinished)="onEditFinished()"></app-contact-edit>
    </section>

    <mat-form-field class="filterField">
      <mat-label>Filtrer</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Votre filtre" #input>
    </mat-form-field>

    <section class="datatable-container">
      <table mat-table appMatTableResponsive [dataSource]="dataSource" matSort multiTemplateDataRows>
        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'contacts.list.client' | translate }} </th>
          <td mat-cell *matCellDef="let contact"> {{ contact.client.name }} </td>
        </ng-container>

        <ng-container matColumnDef="firstname">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'contacts.list.firstname' | translate }} </th>
          <td mat-cell *matCellDef="let contact"> {{ contact.firstname }} </td>
        </ng-container>

        <ng-container matColumnDef="lastname">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'contacts.list.lastname' | translate }} </th>
          <td mat-cell *matCellDef="let contact"> {{ contact.lastname }} </td>
        </ng-container>

        <ng-container matColumnDef="gsm">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'contacts.list.gsm' | translate }} </th>
          <td mat-cell *matCellDef="let contact"> {{ contact.gsm }} </td>
        </ng-container>

        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'contacts.list.phone' | translate }} </th>
          <td mat-cell *matCellDef="let contact"> {{ contact.phone }} </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'contacts.list.email' | translate }} </th>
          <td mat-cell *matCellDef="let contact"> {{ contact.email }} </td>
        </ng-container>

        <ng-container matColumnDef="fax">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'contacts.list.fax' | translate }} </th>
          <td mat-cell *matCellDef="let contact"> {{ contact.fax }} </td>
        </ng-container>

        <ng-container matColumnDef="locality">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'contacts.list.locality' | translate }} </th>
          <td mat-cell *matCellDef="let contact"> {{ contact.locality }} </td>
        </ng-container>

        <ng-container matColumnDef="postalCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'contacts.list.postalCode' | translate }} </th>
          <td mat-cell *matCellDef="let contact"> {{ contact.postalCode }} </td>
        </ng-container>

        <ng-container matColumnDef="street">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'contacts.list.street' | translate }} </th>
          <td mat-cell *matCellDef="let contact"> {{ contact.street }} </td>
        </ng-container>

        <ng-container matColumnDef="streetNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'contacts.list.streetNumber' | translate }} </th>
          <td mat-cell *matCellDef="let contact"> {{ contact.streetNumber }} </td>
        </ng-container>

        <ng-container matColumnDef="service">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'contacts.list.service' | translate }} </th>
          <td mat-cell *matCellDef="let contact"> {{ contact.service }} </td>
        </ng-container>

        <ng-container matColumnDef="site">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'contacts.list.site' | translate }} </th>
          <td mat-cell *matCellDef="let contact"> {{ contact.site }} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> {{ 'contacts.list.actions' | translate }} </th>
          <td mat-cell *matCellDef="let contact">
            <ng-container *ngIf="contact.id !== editedId && isDispatcher">
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                [matTooltip]="'contacts.list.edit' | translate" (click)="onEdit(contact.id)">
                <mat-icon aria-label="Edit">edit</mat-icon>
              </button>
            </ng-container>
            <ng-container *ngIf="isDispatcher">
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                [matTooltip]="'contacts.list.delete' | translate" (click)="delete(contact.id)">
                <mat-icon aria-label="Delete">delete</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let contact" [attr.colspan]="displayedColumns.length">
            <div *ngIf="contact.id === editedId" class="row-edit"
              [@detailExpand]="contact.id === editedId ? 'expanded' : 'collapsed'">
              <app-contact-edit [contact]="contact" (editFinished)="onEditFinished()"></app-contact-edit>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row"
          [ngClass]="{ 'expanded-row': row.id === editedId }"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
      </table>
      <mat-paginator class="paginator" [pageSizeOptions]="[20, 25, 50, 100]" showFirstLastButtons></mat-paginator>
    </section>
    <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
  </mat-card-content>
</mat-card>